/** Claves del acordeón en FichaOdontologicaForm (modo edición). */

export const FICHA_ACCORDION_KEYS = {

  personal: 'personal',

  medica: 'medica',

  odontologica: 'odontologica',

  consentimiento: 'consentimiento',

  msp: 'msp-odonto',

  seguro: 'seguro',

};



/** Secciones de Historia clínica (vista lectura) → acordeón del modal. */

export const HISTORIAL_TO_ACCORDION = {

  medica: FICHA_ACCORDION_KEYS.medica,

  odontologica: FICHA_ACCORDION_KEYS.odontologica,

  consentimiento: FICHA_ACCORDION_KEYS.consentimiento,

  msp: FICHA_ACCORDION_KEYS.msp,

  seguro: FICHA_ACCORDION_KEYS.seguro,

  personal: FICHA_ACCORDION_KEYS.personal,

};



export function historialSectionLabel(sectionId) {

  const labels = {

    medica: 'Historia médica general',

    odontologica: 'Historia odontológica',

    consentimiento: 'Consentimiento informado',

    msp: 'Indicadores MSP y planes',

    seguro: 'Seguro y administrativa',

    personal: 'Información personal',

  };

  return labels[sectionId] || 'Ficha odontológica';

}



/** Metadatos para navegación y encabezados del modal de ficha. */

export const FICHA_MODAL_SECTIONS = [

  {

    key: FICHA_ACCORDION_KEYS.personal,

    icon: 'bi-person-vcard-fill',

    title: 'Información personal',

    desc: 'Identificación, contacto y domicilio',

    color: '#5D87FF',

  },

  {

    key: FICHA_ACCORDION_KEYS.medica,

    icon: 'bi-heart-pulse-fill',

    title: 'Historia médica general',

    desc: 'Alergias, medicación y antecedentes',

    color: '#FA896B',

  },

  {

    key: FICHA_ACCORDION_KEYS.odontologica,

    icon: 'bi-tooth-fill',

    title: 'Historia odontológica',

    desc: 'Consulta, signos vitales y examen',

    color: '#13DEB9',

  },

  {

    key: FICHA_ACCORDION_KEYS.consentimiento,

    icon: 'bi-pen-fill',

    title: 'Consentimiento informado',

    desc: 'Documento legal y firma del paciente',

    color: '#7460EE',

  },

  {

    key: FICHA_ACCORDION_KEYS.msp,

    icon: 'bi-clipboard2-data-fill',

    title: 'Indicadores MSP',

    desc: 'Índices y planes clínicos',

    color: '#49BEFF',

  },

  {

    key: FICHA_ACCORDION_KEYS.seguro,

    icon: 'bi-shield-check',

    title: 'Seguro y administrativa',

    desc: 'Cobertura, póliza y notas',

    color: '#FFAE1F',

  },

];



export function fichaModalSectionByKey(key) {

  return FICHA_MODAL_SECTIONS.find((s) => s.key === key) || FICHA_MODAL_SECTIONS[0];

}


